import { AppConfig } from './AppConfig';

const baseUrl = 'http://tower-server-02.pulsar.be';
const basePlannerUrl = 'http://tower-server-02.pulsar.be:8080';

const config: AppConfig = {
  configName: 'W-DEVL-06',
  applicationTitle: 'Pharmagardes',
  hubUrl: `${baseUrl}/webgardes_devl/pharmagardeHub`,
  apiUrl: `${baseUrl}/webgardes_devl/api/`,
  plannerApiUrl: `${basePlannerUrl}/planner/`,
  googleMapApiKey: 'AIzaSyAHKfZ1yH7pudlmQ4441Plv9Aiic1tunQc',
  dateFormat: 'DD/MM/YYYY',
  dateFormatWithDay: 'ddd DD/MM/YYYY',
  dateTimeFormat: 'DD/MM/YYYY HH:mm',
};

export default config;
